import { Injectable } from '@angular/core';
import { BaseAPIClass } from '@app/core/class/baseAPI.class';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment.prod';

@Injectable()
export class UnidadService extends BaseAPIClass {
  baseUrl = '';
  constructor(protected httpClient: HttpClient) {
    super(httpClient);
    this.baseUrl = this.baseUrl + '/unidades';
  }

  /* getExistencia(obje){

  }*/
}
